import { useContext, useLayoutEffect } from "react";
import appGlobalsContext from "app/AppGlobalsContext";

// react-calendar sets an inline `margin-left` (physical, not logical) on the first tile as a JS
// runtime style, so postcss-rtlcss can't flip it — it only processes authored CSS. Move it to the
// correct side under RTL ourselves.
export default (containerRef, month) => {
	const { isRTL } = useContext(appGlobalsContext);

	useLayoutEffect(() => {
		const firstTile = containerRef.current?.querySelector(
			".react-calendar__month-view__days .react-calendar__tile"
		);
		if (!firstTile) {
			return;
		}

		const marginLeft = parseFloat(firstTile.style.marginLeft) || 0;
		const marginRight = parseFloat(firstTile.style.marginRight) || 0;

		if (isRTL && marginLeft) {
			firstTile.style.marginRight = firstTile.style.marginLeft;
			firstTile.style.marginLeft = "0";
		} else if (!isRTL && marginRight) {
			firstTile.style.marginLeft = firstTile.style.marginRight;
			firstTile.style.marginRight = "0";
		}
	}, [containerRef, month, isRTL]);
};
